module.exports = __webpack_public_path__ + "static/media/monkey-fishing.bdf68d49.png";